import { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import lottie from 'lottie-web';
import { Link } from 'react-router-dom';
import { Button } from 'antd';
import loadingLottie from '../../animations/data-checking-loading-lottie.json';
import { EddLayout } from '../EddLayout';
import { PageHeader } from '../PageHeader';
import styles from './index.module.css';
import { NON_SHIPPING_DAYS_PATH } from '../../constants';

const LOADING_STEPS = ['Checking order history', 'Analyzing order fulfillment time',
  'Collecting shipping information', 'Training predictive models', 'Finishing up'];

const NUMBER_OF_FAKE_STEPS = 4;

const DataChecking = () => {
  const [loadingStep, setLoadingStep] = useState(0);
  const loadingFinished = loadingStep >= NUMBER_OF_FAKE_STEPS;
  const loadingLottieRef = useRef(null);

  useEffect(() => {
    const timer = setInterval(() => {
      setLoadingStep((step) => {
        if (step < NUMBER_OF_FAKE_STEPS) {
          return step + 1;
        }
        clearInterval(timer);
        return step;
      });
    }, 500);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (!loadingLottieRef.current || loadingFinished) {
      return;
    }
    lottie.loadAnimation({
      container: loadingLottieRef.current,
      animationData: loadingLottie,
      loop: true,
    });
    // eslint-disable-next-line consistent-return
    return () => lottie.destroy();
  }, [loadingFinished]);

  return (
    <EddLayout left={(
      <div className={styles.dataChecking}>
        <PageHeader />
        <div className={styles.loadingContent}>
          {loadingFinished ? (
            <div className={styles.loadingPic} />
          ) : <div className={styles.loadingAnimation} ref={loadingLottieRef}></div>}
          <div className={styles.loadingTitle}>
            {loadingFinished ? 'Your AI-powered delivery date estimate is ready to go'
              : 'Crunching numbers,this could take a minute'}
          </div>
          <div className={styles.loadingItems}>
            {LOADING_STEPS.map((item, index) => (
            // eslint-disable-next-line react/no-array-index-key
              <div className={styles.loadingItem} key={index}>
                <div className={classNames(
                  styles.loadingIcon,
                  { [styles.iconFinished]: index <= loadingStep },
                )}
                >
                </div>
                <div className={styles.loadingText}>{item}</div>
              </div>
            ))}
            {loadingStep >= NUMBER_OF_FAKE_STEPS
            && (
            <Link to={{ pathname: NON_SHIPPING_DAYS_PATH, search: 'type=data-sufficient' }}>
              <Button type="primary" className={styles.forwardButton}>Next →</Button>
            </Link>
            )}
          </div>
        </div>
      </div>
  )}
    />
  );
};

export { DataChecking };
